import styled from 'styled-components';

export const List = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 24px;
  justify-content: center;
  margin: 0;
`;

export const Item = styled.li`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
